import { useState, useEffect } from "react";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import DownloadOutlinedIcon from "@mui/icons-material/DownloadOutlined";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import { DataGridPro, gridRowIdsSelector, useGridApiRef } from "@mui/x-data-grid-pro";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { CmpDatePickerField001V1 } from "../../Component/Common/ToolBox/ToolBoxV1";
import GCAutocompleteCheckboxFixSizeUid from "../StockSetupChangeApprove/GCAutocompleteCheckboxFixSizeUid";
import {  Head_Set } from "./SliceStockSetupChangeApprove";
import { vRdxUserInfo } from "../../Redux/roStore";
import {  getStatusStyleV1 } from "../../Utility/Utilitys";
import { getReasonAttribute, ISTCRA_Confirm_Summary } from "../../Server/ApiV2";
import ApproveModal from "./ApproveModal";
import CycleCustomModal from "../../Component/Common/ReuseableComponent/CycleCustomModal";
import Breadcrumbs from "../StockSetupChangeApprove/BreadCrumbs";
import { useLocation } from "react-router-dom";

 const status = ["All", "Enter", "Post"];

export default function StockSetupChangeApprove() {
  const vMediaQuery = useMediaQuery("(max-width:650px)");

 
  const queryParams = useLocation();
  const vRdxUserInfoObj = vRdxUserInfo();
  const pageType = queryParams.search.split("type=")[1];
  const dispatch = useDispatch();
  const apiRef = useGridApiRef();

    const vRdxuserLoc = useSelector(
      (state) => state.SliceDB.value.Location.LocWithRights
    );

    const initialState = {
      dateFrom: moment().startOf("month").toDate(),
      dateTo: moment().toDate(),
      location: vRdxuserLoc?.map((item) => item.Uid),
      status: "All",
    };
    const [open, setOpen] = useState(false);
    const [detailData, setDetailData] = useState([]);
    const [rejectTypeArr, setrejectTypeArr] = useState([]);
    const [filterObj, setFilterObj] = useState(initialState);

  const getReasonTypeAttribute = async () => {
    try {
      const res = await getReasonAttribute();
      if (res?.status === 200) {
        setrejectTypeArr(res?.data?.recordset || []);
      }
    } catch (error) {}
  };

    const fonLoad = async () => {
      const sumFilterRes = await ISTCRA_Confirm_Summary({
        FromDate: moment(filterObj?.dateFrom).format("MM/DD/YYYY"),
        ToDate: moment(filterObj?.dateTo).format("MM/DD/YYYY"),
        Location: Array.isArray(filterObj?.location)
          ? filterObj?.location.join(",")
          : filterObj?.location || "",
        Status: filterObj?.status || "",
        UserCd: vRdxUserInfoObj?.UserID || "",
        Type: pageType,
      });
      if (sumFilterRes?.status === 200) {
        setDetailData(sumFilterRes?.data?.recordset);
      }
    };

  const handleRowClick = (params) => {
    dispatch(Head_Set(params.row));
    setOpen(true);
  };
   const handleExport = () => {
  apiRef.current.exportDataAsCsv({
    getRowsToExport: ({ apiRef }) => gridRowIdsSelector(apiRef),
    includeHeaders: true,
    utf8WithBom: true,
  });
  };
  const handlePrint = () => {
    apiRef.current.exportDataAsPrint();
  };

  useEffect(() => {
    getReasonTypeAttribute();
  }, []);

  useEffect(() => {
    setFilterObj((prev) => ({
      ...prev,
      ...initialState,
    }));
    setDetailData([]);
  }, [pageType]);

  return (
    <>
    <div className="div-container">
      <Box sx={{ mt: { xs: 2, md: 0 } }} >
        <Breadcrumbs pageType={pageType} />
      </Box>
      <Grid
        container
        spacing={{ xs: 1.5, md: 1 }}
        sx={{ alignItems: { xs: "flex-end" }, mt: { xs: 1, sm: 0 } }}
      >
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <Typography>From Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"dateFrom"}
            xValue={filterObj?.dateFrom}
            xOnChange={(val) => {
              setFilterObj({ ...filterObj, dateFrom: val?.$d ?? val });
            }}
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2.5} lg={1.5}>
          <Typography>To Date</Typography>
          <CmpDatePickerField001V1
            xLabelText=""
            xName={"dateTo"}
            xValue={filterObj?.dateTo}
            xOnChange={(val) => {
              setFilterObj({ ...filterObj, dateTo: val?.$d ?? val });
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4.5} lg={4}>
          <Typography>Location</Typography>
          <GCAutocompleteCheckboxFixSizeUid
            options={vRdxuserLoc ?? []}
            xValue={filterObj?.location}
            setValue={(updatedObj) => {
              setFilterObj({ ...filterObj, location: updatedObj });
            }}
            objName="location"
            label=""
            placeholder="Search Location"
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2.5} lg={1.5}>
          <Typography>Status</Typography>
          <FormControl fullWidth>
            <Select
              size="small"
              value={filterObj?.status}
              name="status"
              onChange={(e) => {
                setFilterObj({ ...filterObj, status: e.target.value });
              }}
            >
              {status.map((obj) => (
                <MenuItem key={obj} value={obj}>
                  {obj}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Grid>
        <Grid           
        item
          xs={12}
          sm={9}
          md={12}
          lg={3.5}
          >
          <Box display="flex" justifyContent="flex-end" flexWrap="wrap" gap={1}>
            <Button variant="contained" size="small" onClick={fonLoad}>
              Load
            </Button>
            <Tooltip title="Export CSV">
              <IconButton color="primary" onClick={handleExport} size="small">
                <DownloadOutlinedIcon />
              </IconButton>
            </Tooltip>
            <Tooltip title="Print">
              <IconButton color="primary" onClick={handlePrint} size="small">
                <PrintOutlinedIcon />
              </IconButton>
            </Tooltip>
          </Box>
        </Grid>
      </Grid>
      <Box
        sx={{
          height: { xs: "54vh", sm: "70vh", md: "74vh", lg: "80vh" },
          marginTop: 1,
        }}
      >
        <DataGridPro
          apiRef={apiRef}
          rowHeight={30}
          headerHeight={40}
          rows={detailData ?? []}
          getRowId={(v) => v.A_Transid}
          columns={[
            {
              field: "A_Transid",
              headerName: "TransId",
              align: "center",
              width: 60,
            },
            {
              field: "A_Date",
              headerName: "Date",
              width: 95,
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "Loc_Name",
              headerName: "Location",
              minWidth: 130,
            },
            {
              field: "LPOGruppenName",
              headerName: "LPO Group",
              width: 150,
            },
            {
              field: "A_Narration",
              headerName: "Narration",
              width: 150,
            },
            {
              field: "A_Status",
              headerName: "Status",
              width: 70,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_CM",
              headerName: "CM Status",
              width: 80,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "A_Status_PM",
              headerName: "PM Status",
              width: 75,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "ApproveStatus",
              headerName: "Appr Status",
              width: 90,
              renderCell: (params) => {
                const style = getStatusStyleV1(params.value);
                return (
                  <div
                    style={{
                      ...style,
                      padding: "2px 8px",
                      borderRadius: "4px",
                      textAlign: "center",
                      width: "100%",
                      fontWeight: "bold",
                    }}
                  >
                    {params.value}
                  </div>
                );
              },
            },
            {
              field: "CreatedBy",
              headerName: "Created By",
              width: 110,
            },
            {
              field: "CreatedDt",
              headerName: "Created Date",
              width: 95,
              headerAlign: "center",
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_CM_By",
              headerName: "Appr By CM",
              width: 110,
            },
            {
              field: "A_CM_Dt",
              headerName: "CM Appr Date",
              width: 100,
              headerAlign: "center",
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "A_PM_By",
              headerName: "Appr By PM",
              width: 110,
            },
            {
              field: "A_PM_Dt",
              headerName: "PM Appr Date",
              width: 95,
              headerAlign: "center",
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
            {
              field: "ApprovedBy",
              headerName: "Confirm By",
              width: 110,
            },
            {
              field: "ApproveDt",
              headerName: "Confirm Date",
              width: 95,
              headerAlign: "center",
              align: "center",
              valueFormatter: ({ value }) =>
                moment(value).format("DD/MM/YYYY") == "Invalid date"
                  ? ""
                  : moment(value).format("DD/MM/YYYY"),
            },
          ]}
          hideFooter={true}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0
              ? "mui-even-row"
              : "mui-odd-row"
          }
          sx={{
            border: 1,
            borderColor: "primary.light",
            "& .MuiDataGrid-columnHeaders": {
              backgroundColor: "#0d73bb",
              color: "white",
            },
          }}
          onRowDoubleClick={(params) => {
            handleRowClick(params);
          }}
        />
      </Box>
      <CycleCustomModal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        vMediaQuery={vMediaQuery}
        xMediaQuery={vMediaQuery}
        title={`Stock Setup Change Approve ${pageType}`}
        children={
          <ApproveModal
            rejectTypeArr={rejectTypeArr}
            fonLoad={fonLoad}
            handleClose={() => setOpen(false)}
            type={pageType}
          />
        }
      />
      </div>
    </>
  );
}
